<div class="app-full-height">
  <div class="flex flex-col m-4">
    <h1>Add a User</h1>
    <form
      [formGroup]="newUserForm"
      class="flex flex-col justify-start items-stretch space-y-2"
    >
      <h2>Personal Details</h2>
      <div
        class="flex md:flex-row flex-col justify-start items-start md:space-x-3"
      >
        <mat-form-field class="md:w-1/3 w-full flex-grow-0 flex-shrink-0">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" placeholder="Name" required />
        </mat-form-field>
        <div class="flex md:w-1/3 w-full flex-grow"></div>
        <div
          class="order-first md:order-last flex flex-col md:w-1/3 w-full flex-grow-0 justify-end items-start bg-teal-50 border-l-4 border-teal-400 text-teal-800 p-4 mb-4 md:mb-0"
        >
          <p>
            This is the name that will appear against actions this user carries
            out, such as hires and bookings.
          </p>
        </div>
      </div>
      <h2>Login Details</h2>
      <div
        class="flex md:flex-row flex-col justify-start items-start md:space-x-3"
      >
        <mat-form-field class="w-full md:w-1/3">
          <mat-label>Email</mat-label>
          <input
            matInput
            formControlName="email"
            placeholder="Email"
            required
          />
          @if (newUserForm.get('email').hasError('conflict')) {
            <mat-error
              >This email address is already assigned to a HireLogic
              user.</mat-error
            >
          }
        </mat-form-field>
        <mat-form-field class="w-full md:w-1/3">
          <mat-label>Username</mat-label>
          <input matInput formControlName="user_name" placeholder="Username" />
        </mat-form-field>
        <div
          class="order-first md:order-last w-full md:w-1/3 flex flex-col justify-end items-start bg-teal-50 border-l-4 border-teal-400 text-teal-800 p-4 mb-4 md:mb-0"
        >
          <p>
            Email is required, username is optional. The user can enter either
            of these when logging in.
          </p>
        </div>
      </div>
      <h2>Password</h2>
      <div
        class="flex md:flex-row flex-col justify-start items-start md:space-x-3"
      >
        <mat-form-field class="w-full md:w-1/3">
          <mat-label>Password</mat-label>
          <input
            matInput
            formControlName="password"
            type="password"
            placeholder="Password"
            required
          />
        </mat-form-field>
        <mat-form-field class="w-full md:w-1/3">
          <mat-label>Retype Password</mat-label>
          <input
            matInput
            formControlName="password_confirmed"
            type="password"
            placeholder="Confirm Password"
            required
          />
        </mat-form-field>
        <div
          class="order-first md:order-last w-full md:w-1/3 flex flex-col justify-end items-start bg-teal-50 border-l-4 border-teal-400 text-teal-800 p-4 mb-4 md:mb-0"
        >
          <p>The user can change this password at any time.</p>
        </div>
      </div>
      <div
        class="flex flex-row justify-end items-center mt-4 space-x-2 md:space-x-4"
      >
        <button mat-raised-button type="button" (click)="backToList()">
          Cancel
        </button>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="!newUserForm.valid"
          (click)="save()"
        >
          Save User
        </button>
      </div>
    </form>
  </div>
</div>
